import { CreateMixin } from "@pdfking/reactivity/preact"
import { ArrayQ } from "@pdfking/structs"

import { InputMixin } from "./InputMixin"

export type GroupedChoices = [string, Record<string, string>][]
export type FlatChoices = Record<string, string>
export type AnyChoices = FlatChoices | GroupedChoices

export const SelectMixin = CreateMixin({
  mixins: [InputMixin] as const,
  computed: {
    expanded_choices(): [string | undefined, Record<string, string>][] {
      const c = this.choices
      if (ArrayQ(c)) return c
      return [[undefined, c]]
    },
  },
  props: {
    choices: {} as AnyChoices,
    onselect: undefined as ((key: string | string[]) => void) | undefined,
  },
})
